import useResponsiveDesign from 'hooks/useResponsiveDesign'
import Styles from './Empty.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button'
import { Icon } from 'blaze-ui/icons/Types'
import { useUserRole } from 'hooks/useUserRole'

const EMPTY_BG_DESKTOP =
  'https://res.cloudinary.com/almanac/image/upload/v1730400712/blaze_assets/analytics/desktop-empty.png'
const EMPTY_BG_MOBILE =
  'https://res.cloudinary.com/almanac/image/upload/v1730402624/blaze_assets/analytics/mobile-empty.png'

interface ButtonProps {
  label: string
  onPress: () => void
  frontIcon?: Icon
}

export interface EmptyProps {
  icon?: React.ReactNode
  text?: string
  title?: string
  buttonProps?: ButtonProps
}

export const Empty = ({ icon, text, buttonProps, title }: EmptyProps) => {
  const { isMobile } = useResponsiveDesign()
  const src = isMobile ? EMPTY_BG_MOBILE : EMPTY_BG_DESKTOP
  const role = useUserRole()
  const canShowButton = role === 'admin' || role === 'super_admin'

  return (
    <div className={Styles.empty}>
      <div className={Styles.cta}>
        {icon}
        {title && <Heading level={2}>{title}</Heading>}
        <Heading level={4}>{text}</Heading>
        {buttonProps && canShowButton && (
          <Button onPress={buttonProps.onPress} variant="primary" frontIcon={buttonProps.frontIcon}>
            {buttonProps.label}
          </Button>
        )}
      </div>
      <img src={src} alt="Empty" className={Styles.image} />
    </div>
  )
}
